import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import { ConstantMan } from './constantMan';
import { Router } from '@angular/router';
import {BuyScheduleChangeRequest} from "../models/buyScheduleChangeRequest";

@Injectable()
export class ApiHelper {
  private accessToken: any;
  private env: string;
  private serviceName: string;
  private dataServiceName: string;
  private callServiceName: string;
  private detServiceName: string;
  private seedServiceName: string;
  public embedUrl: string;
  public dniEmbedUrl: string;
  private resources: Map<string, string> = new Map();
  private busySource = new Subject<any>();
  private apiErrorSource = new Subject<any>();
  private origin: string;
  private calendlyURI: string;

  busyChange$ = this.busySource.asObservable();
  apiErrorChange$ = this.apiErrorSource.asObservable();

  constructor(private httpClient: HttpClient, private router: Router) {}

  //config functions
  public setResources(name: string, resource: string) {
    this.resources.set(name, resource);
  }

  public setEnvironment(enletg: string) {
    this.env = enletg;
    switch (enletg) {
      case 'local':
        this.serviceName = ConstantMan.API.BASE.LOCAL;
        this.embedUrl = ConstantMan.API.EMBED.LOCAL;
        this.dniEmbedUrl = ConstantMan.API.DNI_EMBED.LOCAL;
        this.dataServiceName = ConstantMan.API.DATA.LOCAL;
        this.callServiceName = ConstantMan.API.CALL.LOCAL;
        this.detServiceName = ConstantMan.API.DET.LOCAL;
        this.seedServiceName = ConstantMan.API.RESEED.LOCAL;
        this.origin = ConstantMan.ORIGIN.LOCAL;
        this.calendlyURI = ConstantMan.CALENDLY.LOCAL;
        break;
      case 'dev':
        this.serviceName = ConstantMan.API.BASE.DEV;
        this.embedUrl = ConstantMan.API.EMBED.DEV;
        this.dniEmbedUrl = ConstantMan.API.DNI_EMBED.DEV;
        this.dataServiceName = ConstantMan.API.DATA.DEV;
        this.callServiceName = ConstantMan.API.CALL.DEV;
        this.detServiceName = ConstantMan.API.DET.DEV;
        this.seedServiceName = ConstantMan.API.RESEED.DEV;
        this.origin = ConstantMan.ORIGIN.DEV;
        this.calendlyURI = ConstantMan.CALENDLY.DEV;
        break;
      case 'stage':
        this.serviceName = ConstantMan.API.BASE.STAGE;
        this.embedUrl = ConstantMan.API.EMBED.STAGE;
        this.dniEmbedUrl = ConstantMan.API.DNI_EMBED.STAGE;
        this.dataServiceName = ConstantMan.API.DATA.STAGE;
        this.callServiceName = ConstantMan.API.CALL.STAGE;
        this.detServiceName = ConstantMan.API.DET.STAGE;
        this.seedServiceName = ConstantMan.API.RESEED.STAGE;
        this.origin = ConstantMan.ORIGIN.STAGE;
        this.calendlyURI = ConstantMan.CALENDLY.STAGE;
        break;
      case 'prod':
        this.serviceName = ConstantMan.API.BASE.PROD;
        this.embedUrl = ConstantMan.API.EMBED.PROD;
        this.dniEmbedUrl = ConstantMan.API.DNI_EMBED.PROD;
        this.dataServiceName = ConstantMan.API.DATA.PROD;
        this.callServiceName = ConstantMan.API.CALL.PROD;
        this.detServiceName = ConstantMan.API.DET.PROD;
        this.seedServiceName = undefined;
        this.origin = ConstantMan.ORIGIN.PROD;
        this.calendlyURI = ConstantMan.CALENDLY.PROD;
        break;
      default:
        this.serviceName = ConstantMan.API.BASE.CUSTOM;
        this.embedUrl = ConstantMan.API.EMBED.DEV;
        this.dniEmbedUrl = ConstantMan.API.DNI_EMBED.DEV;
        this.dataServiceName = ConstantMan.API.DATA.CUSTOM;
        this.callServiceName = ConstantMan.API.CALL.DEV;
        this.detServiceName = ConstantMan.API.DET.CUSTOM;
        this.seedServiceName = ConstantMan.API.RESEED.DEV;
        this.origin = ConstantMan.ORIGIN.CUSTOM;
        this.calendlyURI = ConstantMan.CALENDLY.DEV;
        // this.env = 'dev';
    }
  }

  public getRelativePath(resName: string): string {
    return this.getFullPath(resName, true);
  }

  public getResPath(resName: string, relPath: boolean): string {
    return this.getFullPath(this.resources.get(resName), relPath);
  }

  public getOrigin() {
    return this.origin;
  }

  public getEnv(): string {
    return this.env
  }


  public getCalendlyURI() {
    return this.calendlyURI;
  }

  public reseed() {
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.apiCall(this.seedServiceName, 'DELETE', null, null, headers);
  }

  public getServiceName(type?: string): string {
    if (type) {
      switch (type) {
        case 'data':
          return this.dataServiceName;
        case 'call':
          return this.callServiceName;
        case 'det':
          return this.detServiceName;
        default:
          return this.serviceName;
      }
    } else {
      return this.serviceName;
    }
  }

  public getFullPath(res: string, relPath: boolean): string {
    let path: string;
    if (relPath) {
      path = res;
    } else {
      path = this.serviceName + res;
    }
    return path;
  }

  public getDefaultHeader(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    let token = this.getAccessToken();
    /* Was getting back 'undefined' as a string so changed !token to check more thoroughly */
    if (token === null || token === undefined || (typeof token === 'string' && token === 'undefined')) {
      return headers;
    }

    //unlike the deprecated Headers this set() doesn't modify the original object...so return
    headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }

  public getChangeManagementPublicHeaders(publicId: string): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set('Authorization', `Bearer ${publicId}`);
    return headers;
  }

  /**
   * Returns an observable of the specified resource type
   */
  //TODO lock headers to httpHeaders
  public apiCall<T>(
    url: string,
    method: string,
    params: any,
    data: any,
    headers: any,
    resource?: string,
    blob?: boolean,
    loadIndicator: boolean = true
  ): Observable<T> {
    if (resource) {
      url = url + resource;
    }
    if (!data) {
      data = {};
    }

    let initObj = {};
    if (headers) {
      initObj['headers'] = headers as HttpHeaders;
    }
    if (params) {
      initObj['params'] = params;
    }
    if (blob) {
      initObj['responseType'] = 'blob';
    }

    let callHttpRequest: HttpRequest<T>;
    /* see the comments by the two actual methods */
    if (ConstantMan.API.GET_METHODS.some(methodName => method === methodName)) {
      callHttpRequest = this.nonpayloadHttpRequest<T>(method, url, initObj);
    } else {
      callHttpRequest = this.payloadHttpRequest<T>(method, url, data, initObj);
    }

    let apiCallObservable: Observable<T> = new Observable(observer => {
      let httpRequest = this.httpClient.request<T>(callHttpRequest).pipe(share());
      if (loadIndicator) {
        this.setBusy(httpRequest);
      }
      httpRequest.subscribe(
        (data: HttpResponse<T>) => {
          /**
           * This check handles the CORS preflight OPTIONS request.  It won't be an instance of HtppResponse
           * since it has no body.  We want to ignore these as long as they come back with a 2xx status code.
           * Interceptor should handle the errors
           */
          if (data instanceof HttpResponse) {
            if (data.status === 401) {
              this.handleApiError(data);
              observer.next({ firstName: '', roles: [] } as any);
              observer.complete();
            } else {
              observer.next(data.body);
              observer.complete();
            }
          } else {
            //console.log("Thats the 204");
          }
        },
        err => {
          this.handleApiError(err);
          observer.error(err);
        }
      );
    });

    return apiCallObservable;
  }

  public put<T>(
    url: string,
    params: any,
    data: any,
  ): Observable<T> {
    return this.apiCall(url, 'PUT', params, data, this.getDefaultHeader())
  }

  public post<T>(
    url: string,
    params: any,
    data: any,
  ): Observable<T> {
    return this.apiCall(url, 'POST', params, data, this.getDefaultHeader())
  }

  public get<T>(
    url: string,
    params: any,
    data: any,
  ): Observable<T> {
    return this.apiCall(url, 'GET', params, data, this.getDefaultHeader())
  }

  public delete<T>(
    url: string,
    params: any,
    data: any,
  ): Observable<T> {
    return this.apiCall(url, 'DELETE', params, data, this.getDefaultHeader())
  }

  /**
   * For request methods without a data payload, I.E. 'DELETE' | 'GET' | 'HEAD' | 'JSONP' | 'OPTIONS'.
   * The HttpClient constructor definition for these call types doesn't have a data/body parameter.
   *
   * If the same four default parameters were to be passed to a GET method it would try to use the body parameters
   * as the init parameter(appending them as URL query parameters and then ignoring the actual init parameter)
   *
   * Takes three parameters by default
   */
  private nonpayloadHttpRequest<T>(method: string, url: string, params: any): HttpRequest<T> {
    return new HttpRequest<T>(method, url, params);
  }

  /**
   * For request methods that commonly have a data payload, I.E. 'POST' | 'PUT' | 'PATCH',
   * also the default call, to match the actual HttpClient constructor definitions.
   *
   * Takes four parameters by default
   */
  private payloadHttpRequest<T>(method: string, url: string, data: any, params: any): HttpRequest<T> {
    return new HttpRequest<T>(method, url, data, params);
  }

  public handleApiError(apiError) {
    const applicationError = apiError.error;
    if (apiError && applicationError && applicationError.isAdvocadoApplicationError) {
      if (!applicationError.disableDefaultHandling) {
        this.setApiError({
          title: applicationError.name,
          message: applicationError.description,
          technicalInfo: apiError.status + ' ' + apiError.statusText,
        });
      }
    } else {
      this.legacyErrorHandling(apiError);
    }
  }

  public setAccessToken(token: string) {
    this.accessToken = token;
    window.localStorage.setItem('accessToken', token);
  }

  public removeAccessToken() {
    this.accessToken = null;
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('advocado_brand');
    window.localStorage.removeItem('advocado_advertiser');
  }

  public getAccessToken() {
    this.accessToken = window.localStorage.getItem('accessToken');
    if (!this.accessToken) {
      this.accessToken = window.localStorage.getItem('inviteToken');
    }
    return this.accessToken;
  }

  public setBusy(busy: Observable<any>) {
    this.busySource.next(busy);
  }

  public setApiError(apiError) {
    console.log(apiError);
    this.apiErrorSource.next(apiError);
  }

  private legacyErrorHandling(apiError): void {
    if (apiError.hasOwnProperty('status')) {
      switch (apiError.status) {
        case 400:
          if (apiError.url.includes('integrations')) {
            this.setApiError({
              title: 'Integration error',
              message: 'No ad accounts found'
            });
          } else {
            this.setApiError({
              title: apiError.status + ' ' + apiError.statusText,
              message: apiError._body
            });
          }
          break;
        case 401:
          console.log('Unauthorized');
          if (apiError.url.includes('invite')) {
            if (apiError.body === 'This user has already been invited') {
              this.setApiError({
                title: 'Already Invited',
                message: 'This email address has already been invited to the platform.'
              });
            } else {
              this.setApiError({
                title: 'Invite Redeemed',
                message: 'This invitation has already been redeemed. Please login.'
              });
              this.router.navigate(['/login']);
            }
          } else if (apiError.url.includes('linkAccount')) {
            this.setApiError({
              title: 'Invalid Account',
              message: 'This is not a valid Google Ads account. Please try a different account.'
            });
            break;
          } else if (apiError.url.includes('integrations')) {
            // for when user doesn't have access to connecting twitter integration
            this.setApiError({
              title: 'Unauthorized Integration Access',
              message: 'You are not authorized to access this resource.'
            });
            break;
          } else if (apiError.url.includes('session')) {
            // when an accessToken is expired or doesn't exist in database
            this.removeAccessToken();
          } else {
            this.setApiError({
              title: 'Unauthorized',
              message: 'Please try logging in again.'
            });
            setTimeout(() => {
              window.location.href =
                  window.location.href
                      .split('/')
                      .slice(0, 3)
                      .join('/') + '/login';
            }, 5000);
          }
          break;
        case 403:
          console.log('Forbidden');
          if (!apiError.url) {
            this.setApiError({
              title: 'Access Forbidden',
              message: 'You do not currently have access to that resource.'
            });
            this.router.navigate(['/manage']);
          } else if (apiError.url.includes('login')) {
            this.setApiError({
              title: 'Login Failed',
              message: 'The email / password combination was invalid.'
            });
            this.router.navigate(['/login']);
          } else if (apiError.url.includes('reset')) {
            this.setApiError({
              title: 'Token Expired',
              message: 'You cannot cannot reset your password at this time.'
            });
            this.router.navigate(['/login']);
          } else {
            this.setApiError({
              title: 'Access Forbidden',
              message: 'You do not currently have access to that resource.'
            });
            this.router.navigate(['/manage']);
          }
          break;
        case 404:
          console.log('Not Found');
          this.setApiError({
            title: '404',
            message: 'Page not found.'
          });
          this.router.navigate(['/four-oh-four']);
          break;
        case 500:
          if (apiError.url.includes('google_tag_manager/create')) {
            this.setApiError({
              title: "Error Installing Tracking Tag",
              message: "Does the tag already exist in the specified workspace?"
            });
            break;
          }
        default:
          if (apiError.error === 'Facebook user does not have write access for ad account') {
            this.setApiError({
              title: apiError.status,
              message: apiError.error
            });
          } else if (apiError.url.includes('adblocker')) {
            this.setApiError({
              title: 'You seem to be using an AdBlocker',
              message: 'AdBlockers may cause unexpected errors on this site. Please turn off AdBlocker and refresh'
            });
          } else {
            this.setApiError({
              title: apiError.status + ' ' + apiError.statusText,
              message: apiError._body
            });
          }
      }
    } else {
      console.log('unhandled API error');
    }
  }
}
